/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["поноћ","подне","ујутро","по подне","увече","ноћу"],["поноћ","подне","ујутру","по подне","увече","ноћу"],u],[["поноћ","подне","јутро","поподне","вече","ноћ"],u,u],["00:00","12:00",["06:00","12:00"],["12:00","18:00"],["18:00","21:00"],["21:00","06:00"]]];
